import apiUrl from "../../../../../utils/settings";

export const annualTripDetailsUrl = () => {
  return apiUrl + "/benefits-v2/annual-trip-details";
};

export const downloadTripVoucherUrl = () => {
  return apiUrl + "/benefits-v2/annual-trip-voucher";
};

export const annualTripConfimationDownloadUrl = () => {
  return apiUrl + "/benefits-v2/insurance-card";
};